export enum LocationPartnerStatus {
  AVAILABLE = "AVAILABLE",
  CURRENTLY_INSTALLING = "CURRENTLY_INSTALLING",
  RESERVED = "RESERVED",
  TEMPORARILY_SUSPENDED = "TEMPORARILY_SUSPENDED",
  MAINTENANCE = "MAINTENANCE",
}

export enum LocationPartnerStatusEnumMapping {
  AVAILABLE = "enumMapping.LocationPartnerStatus.lowercase.AVAILABLE",
  CURRENTLY_INSTALLING = "enumMapping.LocationPartnerStatus.lowercase.CURRENTLY_INSTALLING",
  RESERVED = "enumMapping.LocationPartnerStatus.lowercase.RESERVED",
  TEMPORARILY_SUSPENDED = "enumMapping.LocationPartnerStatus.lowercase.TEMPORARILY_SUSPENDED",
  MAINTENANCE = "enumMapping.LocationPartnerStatus.lowercase.MAINTENANCE",
}
export interface LocationPartnerStatusInterface {
  id: LocationPartnerStatus;
  value: string;
}
